module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/ofset/ofset.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/ofset/ofset.component.html
// module chunks = main